import * as React from "react";
import { SVGProps } from "react";
const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M1.82251 1H10.1808V2.56693H1.82251V1Z" fill="#6B767C" />
    <path
      d="M3.3358 6.30159H2.03003V3.97732H5.3493V1.29004H6.65508V5.28309H3.3358V6.30159Z"
      fill="#6B767C"
    />
    <path
      d="M8.70517 6.30394L8.69734 5.28282H6.00222V3.97705H9.99397L10.0109 6.29349L8.70517 6.30394ZM4.77741 11.1614H0.549316V6.20992H4.77741V11.1614ZM1.78458 9.92746H3.54345V7.44388H1.78458V9.92746Z"
      fill="#6B767C"
    />
    <path
      d="M11.4368 11.1615H7.20874V6.20996H11.4368V11.1615ZM8.4427 9.9275H10.2016V7.44392H8.4427V9.9275Z"
      fill="#6B767C"
    />
  </svg>
);
export default SVGComponent;
